
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    h2Text: {
      type: String,
      default: 'Hello'
    },
    h1Text: {
      type: String,
      default: 'We\'re Excited <br/> to Hear from You!'
    },
    h4Text: {
      type: String,
      default: 'Thank You for Submitting Contact Request! <br/>\n' +
          '      Our agents will get back to you within 24 hours'
    },
    btnText: {
      type: String,
      default: 'close'
    }
  },
  computed: {
    homeLink() {
      return this.$i18n.locale === 'id'
          ? '/id/home'
          : this.$i18n.locale === 'es'
              ? '/es/inicio'
              : '/'
    }
  }
}
